var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Context',{attrs:{"overflow-scroll":true,"max-height-if-outside-viewport":true}},[_c('ul',{staticClass:"context__menu"},_vm._l((_vm.hiddenRecords),function(value){return _c('li',{key:'hidden-record' + value.id,staticClass:"expand-on-overflow-hidden-context__dropdown-item"},[_vm._v("\n      "+_vm._s(value[_vm.nameKey])+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }